// Multi-App Platform Configuration
export const PLATFORM_CONFIG = {
  name: "Selkirk Copper Platform",
  version: "1.0.0",
  domain: "app.selkirkcopper.com"
};

// Application Registry
export const APPLICATIONS = {
  wolfwalker: {
    id: 'wolfwalker',
    name: 'Wolfwalker',
    description: 'Unified data platform with QGIS integration',
    iconId: 'app-wolfwalker',
    path: '/wolfwalker',
    securityGroups: ['5adee6de-74a1-454b-8497-b8c39a8cebf7'], // Minto-QGIS-Users
    color: '#2563eb',
    status: 'hidden' // Hidden from interface - contains debug/test features
  },
  drillingDashboard: {
    id: 'drilling-dashboard',
    name: 'Drilling Dashboard',
    description: 'Drilling data analytics and visualization',
    iconId: 'app-drilling-dashboard',
    path: '/drilling-dashboard',
    securityGroups: ['f870ebf3-ff3f-48e8-b1e3-fa73f9b14618'], // drilling-dashboard-sg
    color: '#dc2626',
    status: 'active'
  },
  claimManagement: {
    id: 'claim-management',
    name: 'Claim Management',
    description: 'Interactive QGIS map for quartz claims management',
    iconId: 'app-claim-management',
    path: '/claim-management',
    securityGroups: ['5adee6de-74a1-454b-8497-b8c39a8cebf7'], // Minto-QGIS-Users
    color: '#f59e0b',
    status: 'active'
  },
  sampleTracking: {
    id: 'sample-tracking',
    name: 'Sample Tracking',
    description: 'Track sample dispatch, workorders, and lab progress',
    iconId: 'app-sample-tracking',
    path: '/sample-tracking',
    securityGroups: ['cd9e868f-9756-4fac-84d2-b9e2680962f9'], // Sample-Tracking-Users
    color: '#10b981',
    status: 'active'
  },
  assayCompositing: {
    id: 'assay-compositing',
    name: 'Assay Compositing',
    description: 'Composite assay intervals and analyze geochemical data',
    iconId: 'app-assay-compositing',
    path: '/assay-compositing',
    securityGroups: ['7dd0eea2-8a0e-4b11-adea-02d59c779001'], // Assay-Compositing-Users
    color: '#8b5cf6',
    status: 'active'
  },
  qaqc: {
    id: 'qaqc',
    name: 'QAQC',
    description: 'Quality assurance and quality control for drilling data',
    iconId: 'app-qaqc',
    path: '/qaqc',
    securityGroups: ['b09f7b5b-7cb8-43bf-b20f-e1b4f2bd5391'], // QAQC-Users
    color: '#06b6d4',
    status: 'active'
  },
  drillingCosts: {
    id: 'drilling-costs',
    name: 'Drilling Costs',
    description: 'Track and analyze drilling costs and budgets',
    iconId: 'app-drilling-costs',
    path: '/drilling-costs',
    securityGroups: ['47a5606c-a7f9-4967-a4bd-e86bf40e0b6c'], // wlfwkr-drilling-costs-users
    color: '#eab308',
    status: 'active'
  },
  deviationWizard: {
    id: 'deviation-wizard',
    name: 'Deviation Wizard',
    description: 'Survey deviation calculations and corrections',
    iconId: 'app-deviation-wizard',
    path: '/deviation-wizard',
    securityGroups: ['a81073dd-b937-42f3-b1ce-0558ca9e18df'], // Deviation-Wizard-Users
    color: '#10b981',
    status: 'active'
  },
  drillholeValidation: {
    id: 'drillhole-validation',
    name: 'Drillhole Validation',
    description: 'Validate all data associated with drillholes',
    iconId: 'app-drillhole-validation',
    path: '/drillhole-validation',
    securityGroups: ['f870ebf3-ff3f-48e8-b1e3-fa73f9b14618'], // drilling-dashboard-sg
    color: '#3b82f6',
    status: 'active'
  },
  labApprovals: {
    id: 'lab-approvals',
    name: 'Lab Approvals',
    description: 'Manage and approve laboratory workorders',
    iconId: 'app-lab-approvals',
    path: '/lab-approvals',
    securityGroups: ['dba9badd-b0af-48ea-b3fb-44337e9c7188'], // wlfwkr-lab-approvals
    color: '#3b82f6',
    status: 'active'
  },
  docusign: {
    id: 'docusign',
    name: 'DocuSign',
    description: 'DocuSign connection and envelope API (diagnostics)',
    iconId: 'app-docusign',
    path: '/docusign',
    securityGroups: [
      'dba9badd-b0af-48ea-b3fb-44337e9c7188',
      '8cddf0c2-a75f-4c00-bb59-148a93008d40',
    ],
    color: '#0ea5e9',
    status: 'active'
  },
  debug: {
    id: 'debug',
    name: 'Debug',
    description: 'Debug tools and diagnostics',
    iconId: 'app-debug',
    path: '/debug',
    securityGroups: ['8cddf0c2-a75f-4c00-bb59-148a93008d40'], // wlfwkr-debug
    color: '#6b7280',
    status: 'active'
  },
  whosIn: {
    id: 'whos-in',
    name: "Who's In?",
    description: 'See who is on site and scheduled to be in camp',
    iconId: 'app-whos-in',
    path: '/whos-in',
    securityGroups: ['aba7059d-3149-4cc6-a9a7-9b6b1f39ea77'], // wlfwkr-whosin
    color: '#f9be0b',
    status: 'active'
  },
  dailyReport: {
    id: 'daily-report',
    name: 'Daily Report',
    description: 'Create and view daily operational reports',
    iconId: 'app-daily-report',
    path: '/daily-report',
    securityGroups: ['ddfa84bd-2b06-4d7b-8e3a-c08dc11767fd'], // wlfwkr-dailyreport
    color: '#0d9488',
    status: 'active'
  },
  documentDesign: {
    id: 'document-design',
    name: 'Document Design',
    description: 'Design and manage document templates and layouts',
    iconId: 'app-document-design',
    path: '/document-design',
    securityGroups: ['96cad550-d053-4a58-ac70-7f0ef0974db2'], // wlfwkr-docdesign
    color: '#9333ea',
    status: 'active'
  },
  reportGenerator: {
    id: 'report-generator',
    name: 'Report Generator',
    description: 'Automated report generation and templates',
    iconId: 'app-report-generator',
    path: '/report-generator',
    securityGroups: ['report-users-group-id'], // To be created
    color: '#059669',
    status: 'planned'
  },
  qgisViewer: {
    id: 'qgis-viewer',
    name: 'QGIS Viewer',
    description: 'Standalone QGIS map viewer',
    iconId: 'app-qgis-viewer',
    path: '/qgis-viewer',
    securityGroups: ['5adee6de-74a1-454b-8497-b8c39a8cebf7'], // Same as Wolfwalker
    color: '#7c3aed',
    status: 'planned'
  },
  admin: {
    id: 'admin',
    name: 'Administration',
    description: 'Platform administration and user management',
    iconId: 'app-administration',
    path: '/admin',
    securityGroups: ['platform-admins-group-id'], // To be created
    color: '#374151',
    status: 'planned'
  }
};

// Security Groups Configuration
// Note: Group IDs will be updated after Terraform creates the groups
export const SECURITY_GROUPS = {
  // Existing group (managed outside Terraform)
  '5adee6de-74a1-454b-8497-b8c39a8cebf7': {
    name: 'Wolfwalkers',
    displayName: 'Wolfwalker Platform Users',
    applications: ['wolfwalker', 'claim-management']
  },
  
  // Drilling Dashboard Security Group (manually created)
  'f870ebf3-ff3f-48e8-b1e3-fa73f9b14618': {
    name: 'drilling-dashboard-sg',
    displayName: 'Drilling Dashboard Users',
    applications: ['drilling-dashboard', 'drillhole-validation']
  },
  
  // Sample Tracking Security Group
  'cd9e868f-9756-4fac-84d2-b9e2680962f9': {
    name: 'Sample-Tracking-Users',
    displayName: 'Sample Tracking Users',
    applications: ['sample-tracking'],
    terraformManaged: false
  },
  
  // Assay Compositing Security Group
  '7dd0eea2-8a0e-4b11-adea-02d59c779001': {
    name: 'Assay-Compositing-Users',
    displayName: 'Assay Compositing Users',
    applications: ['assay-compositing'],
    terraformManaged: false
  },
  
  // QAQC Security Group
  'b09f7b5b-7cb8-43bf-b20f-e1b4f2bd5391': {
    name: 'QAQC-Users',
    displayName: 'QAQC Users',
    applications: ['qaqc'],
    terraformManaged: false
  },
  
  // Drilling Costs Security Group
  '47a5606c-a7f9-4967-a4bd-e86bf40e0b6c': {
    name: 'wlfwkr-drilling-costs-users',
    displayName: 'Drilling Costs Users',
    applications: ['drilling-costs'],
    terraformManaged: false
  },
  
  // Deviation Wizard Security Group
  'a81073dd-b937-42f3-b1ce-0558ca9e18df': {
    name: 'Deviation-Wizard-Users',
    displayName: 'Deviation Wizard Users',
    applications: ['deviation-wizard'],
    terraformManaged: false
  },
  
  // Lab Approvals Security Group
  'dba9badd-b0af-48ea-b3fb-44337e9c7188': {
    name: 'wlfwkr-lab-approvals',
    displayName: 'Lab Approvals Users',
    applications: ['lab-approvals', 'docusign'],
    terraformManaged: false
  },
  
  // Debug Security Group
  '8cddf0c2-a75f-4c00-bb59-148a93008d40': {
    name: 'wlfwkr-debug',
    displayName: 'Debug Users',
    applications: ['debug', 'docusign'],
    terraformManaged: false
  },
  
  // Who's In? Security Group
  'aba7059d-3149-4cc6-a9a7-9b6b1f39ea77': {
    name: 'wlfwkr-whosin',
    displayName: "Who's In? Users",
    applications: ['whos-in'],
    terraformManaged: false
  },
  
  // Daily Report Security Group
  'ddfa84bd-2b06-4d7b-8e3a-c08dc11767fd': {
    name: 'wlfwkr-dailyreport',
    displayName: 'Daily Report Users',
    applications: ['daily-report'],
    terraformManaged: false
  },
  
  // Document Design Security Group
  '96cad550-d053-4a58-ac70-7f0ef0974db2': {
    name: 'wlfwkr-docdesign',
    displayName: 'Document Design Users',
    applications: ['document-design'],
    terraformManaged: false
  },
  'report-generators-group-id': {
    name: 'Report-Generators',
    displayName: 'Report Generators',
    applications: ['report-generator'],
    terraformManaged: true
  },
  'platform-admins-group-id': {
    name: 'Platform-Administrators',
    displayName: 'Platform Administrators',
    applications: ['admin', 'wolfwalker', 'drilling-dashboard', 'report-generator'],
    terraformManaged: true
  },
  'qgis-viewers-group-id': {
    name: 'QGIS-Viewers',
    displayName: 'QGIS Viewers',
    applications: ['qgis-viewer'],
    terraformManaged: true
  }
};

// Environment-specific configuration
export const getEnvironmentConfig = () => {
  const hostname = window.location.hostname;
  
  return {
    isDevelopment: hostname.includes('localhost') || hostname.includes('dev.'),
    isProduction: hostname === 'app.selkirkcopper.com',
    baseUrl: window.location.origin,
    apiUrl: hostname === 'app.selkirkcopper.com' 
      ? 'https://app.selkirkcopper.com' 
      : 'https://dev.selkirkcopper.com'
  };
};
